export { InputTrimDirective } from './inputs/input-trim.directive';